<ng-container *ngIf="coupon">
    <div class="w-100 border border-2 px-4 py-2 my-2 rounded-4 d-flex align-items-center bg-white">
        <div class="w-100 d-flex justify-content-between align-items-center">
            <div class="fw-bold">
                <span class="text-warning">Coupon </span>
                {{ coupon.name }}

                <ng-container *ngIf="coupon.type === 'flat'">
                    ({{coupon.amount | currency:'USD':'symbol':'1.2-2'}} off)
                </ng-container>
                <ng-container *ngIf="coupon.type === 'percentage'">
                    ({{coupon.amount}}% off)
                </ng-container>

            </div>
            <div *ngIf="!valueOverride" class="fw-bold text-danger">
                - {{coupon.amount | currency:'USD':'symbol':'1.2-2'}}
                <span class="caption m-0" *ngIf="sale.payment_frequency">{{ sale.payment_frequency | paymentSuffix }}</span>
            </div>
            <div *ngIf="valueOverride" class="fw-bold text-danger">
                - {{valueOverride | currency:'USD':'symbol':'1.2-2'}}
                <span class="caption m-0" *ngIf="sale.payment_frequency">{{ sale.payment_frequency | paymentSuffix }}</span>
            </div>
        </div>
    </div>
</ng-container>
